import React from 'react';
import PropTypes from 'prop-types';
import Pluralize from 'react-pluralize';
import { Confirm } from 'react-confirm-bootstrap';
import { SplitButton, MenuItem } from 'react-bootstrap/lib';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import CategoryModal from '../CategoryModal';

function CategoriesList({ accessoryConfig, updateConfig }) {
  const accessories = (accessoryConfig || {}).accessories || [];
  const categories = (accessoryConfig || {}).categories || [];

  const deleteButton = React.useCallback(
    (_, category) => {
      const removeCategory = (categoryToRemove) => {
        const newCategories = categories.filter(
          (c) => c.id !== categoryToRemove.id,
        );
        const newAccessories = accessories.map((a) => {
          const categoryIds = (a.categoryIds || []).filter(
            (i) => i !== categoryToRemove.id,
          );
          return { ...a, categoryIds };
        });

        updateConfig({
          ...accessoryConfig,
          categories: newCategories,
          accessories: newAccessories,
        });
      };
      return (
        <SplitButton
          title="Edit"
          id={`split-button-basic-${category.id}`}
          onClick={() =>
            CategoryModal({
              accessoryConfig,
              category,
              updateConfig,
            })
          }
        >
          <Confirm
            onConfirm={() => removeCategory(category)}
            body={`Are you sure you want to delete ${category.name}?`}
            title={`Deleting ${category.name}`}
            confirmText="Confirm Delete"
          >
            <MenuItem>Delete</MenuItem>
          </Confirm>
        </SplitButton>
      );
    },
    [categories, accessories, updateConfig],
  );

  return (
    <div>
      <h3>
        <Pluralize
          singular="Category"
          plural="Categories"
          count={categories.length}
        />
      </h3>
      <div className="text-right">
        <button
          className="btn btn-primary"
          onClick={() => CategoryModal({ accessoryConfig, updateConfig })}
        >
          Add Category
        </button>
      </div>
      <BootstrapTable
        striped
        hover
        data={categories}
        tableStyle={{ border: 'none', padding: '20px 0' }}
        bodyStyle={{ paddingBottom: '35px' }}
      >
        <TableHeaderColumn dataField="id" hidden isKey />
        <TableHeaderColumn dataField="name">Category</TableHeaderColumn>
        <TableHeaderColumn
          dataFormat={(_, c) =>
            accessories.filter((a) => (a.categoryIds || []).includes(c.id))
              .length
          }
        >
          Accessories
        </TableHeaderColumn>
        <TableHeaderColumn
          columnClassName="list-action-column"
          dataFormat={deleteButton}
        />
      </BootstrapTable>
    </div>
  );
}

CategoriesList.propTypes = {
  accessoryConfig: PropTypes.object,
  updateConfig: PropTypes.func,
};

export default CategoriesList;
